import React, { PropTypes, Component } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as actions from './actions';

import * as globalActions from '../../../action/CommonActions';

import { FilterGroup, DateRangeFilter } from '../../../components/filter';

import QuoteDetails from './components/QuoteDetails';

import moment from 'moment';

import QuoteApprovalGrid from './components/QuoteApprovalGrid';

import FilterMobileComponent from '../../../components/common/FilterMobileComponent';

import Breakpoint from '../../../utils/breakpoints';

import {
  NitroHeading,
  NitroSearchBar,
  NitroSingleSelect,
  NitroDrawer,
  NitroPanel,
} from 'nitro-components';

import styled from 'styled-components';
import Header from '../../../components/layouts/Header';

import CorporateQuoteApi from '../../../api/CorporateQuoteApi';
import { formateSummary } from '../helper';

const TABLE_ROW_LIMIT = 15;

const Container = styled.section`
  padding-top: 16px;
`;

const RightActions = styled.div`
  float: right;
  margin-bottom: 20px;
`;

const StatusSelect = styled.div`
  display: inline-block;
  margin-left: 30px;
  min-width: 200px;
`;

class MyQuote extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetchingQuotes: false,
      status: -1,
      open: false,
      selQuoteId: '',
      selCountryCode: '',
      selCompanyCode: '',
      dateFilter: {
        value: 1,
        type: 1,
      },
      search: '',
      sortQuery: '',
      currentPage: 0,
      emailList: {},
      userQuotes: [],
      totalUserQuote: 0,
    };
  }

  componentWillMount() {
    const { dateFilter } = this.state;
    this.getQuotes(dateFilter, 0);
  }

  getOptions = dateFilterObject => {
    let { dateFilter } = this.state;
    dateFilter = dateFilterObject || dateFilter;

    let options = {};
    let startDate, endDate;

    if (dateFilter.type === 'custom') {
      startDate = dateFilter.value.start;
      endDate = dateFilter.value.end;
    } else {
      const now = new Date();
      startDate = moment(now)
        .subtract(dateFilter.value, 'year')
        .format('D MMM YY');
      endDate = moment(now).format('D MMM YY');
    }

    if (startDate && endDate) {
      options = {
        startDate,
        endDate,
      };
    }

    return options;
  };

  getQuotes = (dateFilter, currentPage) => {
    const page = currentPage;
    const options = this.getOptions(dateFilter);

    this.setState({
      fetchingQuotes: true,
    });

    CorporateQuoteApi.getUserQuotes({
      status: this.state.status === -1 ? null : this.state.status,
      startDate: options.startDate,
      endDate: options.endDate,
      offset: page * TABLE_ROW_LIMIT,
      limit: TABLE_ROW_LIMIT,
      lookup: this.state.search,
      sort: this.state.sortQuery,
    }).then(data => {
      this.setState({
        fetchingQuotes: false,
        userQuotes: data.Details,
        totalUserQuote: data.Total,
      });
    });
  };

  setFilters = filterDate => {
    this.props.actions.setFilter(filterDate[0]);
    this.setState({
      currentPage: 0,
      dateFilter: filterDate[0],
    });
    this.getQuotes(null, null, filterDate[0], 0);
  };

  setStatus = option => {
    this.setState(
      {
        status: option.value,
      },
      () => {
        this.getQuotes(
          this.props.country,
          this.props.costcenter,
          this.props.dateFilter,
          0
        );
      }
    );
  };

  fetchGridData = (currentPage, sortQuery) => {
    this.setState(
      {
        sortQuery,
        currentPage,
      },
      () => {
        this.getQuotes(null, null, null, currentPage);
      }
    );
  };

  search = text => {
    this.setState(
      {
        search: text.toLowerCase(),
        currentPage: 0,
      },
      () => {
        this.getQuotes(null, null, null, 0);
      }
    );
  };

  onQuoteApprovalRowClick = rowData => {
    const params = {
      quoteId: rowData.props.data.QuoteId,
      countryCode: rowData.props.data.CountryCode,
      companyCode: rowData.props.data.CompanyCode,
    };

    this.openSidePanel(params);
  };

  openSidePanel = ({ quoteId, countryCode, companyCode }) => {
    this.setState({
      selQuoteId: quoteId,
      selCountryCode: countryCode,
      selCompanyCode: companyCode,
      open: true,
    });
  };

  closeSidePanel = () => {
    this.setState({
      open: false,
    });
  };

  sendEmail = params => {
    const id = `${params.QuoteId}-${params.ApproverId}`;
    this.setState({
      emailList: { ...this.state.emailList, [id]: false },
    });

    this.props.actions.sendEmail(params).then(() => {
      this.setState({
        emailList: { ...this.state.emailList, [id]: true },
      });
    });
  };

  render() {
    const { dateFilter, userQuotes } = this.state;
    const { quoteSummary, fetchingQuoteSummary } = this.props;

    const filters = [
      {
        title: 'Time period',
        component: DateRangeFilter,
        options: [
          {
            label: 'Past year',
            value: 1,
          },
          {
            label: 'Past 2 years',
            value: 2,
          },
        ],
        ...dateFilter,
      },
    ];

    const statusList = [
      {
        label: 'All status',
        value: -1,
      },
      {
        label: 'Pending',
        value: 1,
      },
      {
        label: 'Approved',
        value: 2,
      },
      {
        label: 'Declined',
        value: 3,
      },
      {
        label: 'Submitted',
        value: 4,
      },
    ];

    let formattedSummary;
    if (quoteSummary) formattedSummary = formateSummary(quoteSummary);

    return (
      <Container>
        <Breakpoint name="desktop">
          <Header>
            <NitroHeading label="My Quote" header inline noMargin />
          </Header>
        </Breakpoint>

        <NitroPanel padding="16px">
          <Breakpoint name="desktop">
            <FilterGroup
              action={this.setFilters}
              title="Filters"
              icon="filter"
              filters={filters}
            />
          </Breakpoint>

          <Breakpoint name="mobileTablet">
            <FilterMobileComponent
              filter
              onClickFilter={this.setFilters}
              filters={filters}
            />
          </Breakpoint>

          <RightActions>
            <NitroSearchBar
              hintText="Search quote reference, creator name"
              action={text => this.search(text)}
              width={280}
              float="left"
            />

            <StatusSelect>
              <NitroSingleSelect
                value={this.state.status}
                mandatory
                bold
                options={statusList}
                action={this.setStatus}
              />
            </StatusSelect>
          </RightActions>

          <QuoteApprovalGrid
            data={userQuotes}
            getExternalData={this.fetchGridData}
            rowCount={TABLE_ROW_LIMIT}
            onRowClick={this.onQuoteApprovalRowClick}
            currentPage={this.state.currentPage}
            dataFetching={this.state.fetchingQuotes}
          />
        </NitroPanel>

        <NitroDrawer
          isOpen={this.state.open}
          close={this.closeSidePanel}
          noPadding
          width={460}
          variant="white">
          <QuoteDetails
            open={this.state.open}
            quoteId={this.state.selQuoteId}
            countryCode={this.state.selCountryCode}
            companyCode={this.state.selCompanyCode}
            sendEmail={this.sendEmail}
            emailList={this.state.emailList}
            actions={this.props.actions}
            fetchingQuoteSummary={fetchingQuoteSummary}
            {...formattedSummary}
          />
        </NitroDrawer>
      </Container>
    );
  }
}

MyQuote.propTypes = {
  actions: PropTypes.object.isRequired,
  globalActions: PropTypes.object,
};

const mapStateToProps = state => {
  const { quoteSummary, fetchingQuoteSummary } = state.corporateQuote.approval;
  return {
    quoteSummary,
    fetchingQuoteSummary,
    dateFilter: {
      label: 1,
      value: 1,
    },
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch),
  globalActions: bindActionCreators(globalActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(MyQuote);



// WEBPACK FOOTER //
// ./src/features/corporate-quote/workflow/MyQuote.js